import styled from '@emotion/styled'

interface AsideInfoWrapperProps {
  isDense?: boolean
}

export const AsideInfoWrapper = styled.div<AsideInfoWrapperProps>`
  width: 100%;

  ${({ isDense }) =>
    isDense &&
    `& > div {
      padding-inline: 0;
    }
  `}
`
